import article from './article.json';
import home from './home.json';
import chat from './chat.json';

export const faq = { article, home, chat };
